import { LanguageProvider } from '@web_opxp/language';
import { Provider } from 'react-redux';
import { SUBSCRIBE_AVAILABLE_LANGUAGES } from './base/constants';
import ENV from './base/env';
import { CheckoutApp } from './checkout';
import getStore from './checkout/store';

const CheckoutWrapper = () => {
  return (
    <Provider store={getStore()}>
      <LanguageProvider
        localesPath={ENV.LocalesBaseUrl}
        ns={['common', 'common.common', 'subscribe', 'prereg', 'common.auth', 'common.countries']}
        defaultNS="subscribe"
        fallbackNS="common"
        supportedLngs={SUBSCRIBE_AVAILABLE_LANGUAGES}
      >
        <CheckoutApp />
      </LanguageProvider>
    </Provider>
  );
};

export default CheckoutWrapper;
